import React from 'react';
import { createCommand, Option } from '@commander-js/extra-typings';
import { NO_TTY_JSON_OUTPUT_OPTION } from '@wix/cli-command-contract';
import type { AstroCommandServices } from '@wix/cli-command-contract';
import { renderCommand, runCommand } from './render-command.js';

export const translationPushCommand = (
  services: AstroCommandServices,
  cliVersion: string
) => {
  return createCommand('push')
    .description(
      'Pushes local translation file `src/translations.json` to Wix Multilingual'
    )
    .addOption(
      new Option(NO_TTY_JSON_OUTPUT_OPTION, 'Output in JSON format').hideHelp()
    )
    .action(async (opts, command) => {
      if (opts.json) {
        return runCommand(command, services, cliVersion, async (model) => {
          const { nonInteractiveTranslationPush } = await import(
            '../non-interactive/translation-push.js'
          );
          return nonInteractiveTranslationPush(services, model);
        });
      }

      const { TranslationPushCommand } = await import(
        '../components/TranslationPushCommand/index.js'
      );

      await renderCommand(
        command,
        services,
        cliVersion,
        <TranslationPushCommand />
      );
    });
};
